module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": function (el, done) {
        _vm.pageFadeIn(el, done);
        _vm.animateAll();
      },
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ShakeMesh', {
    ref: "@landing@shake@nike",
    attrs: {
      "vms": "@landing@shake@nike",
      "link": require('./img/shake/nike.png')
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s1 = v
      },
      "exec": function (v) {
        _vm.execStack.s1 = v
      }
    }
  }), _vm._v(" "), _c('ShakeMesh', {
    ref: "@landing@shake@boxing",
    attrs: {
      "vms": "@landing@shake@boxing",
      "link": require('./img/shake/boxing.png')
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s2 = v
      },
      "exec": function (v) {
        _vm.execStack.s2 = v
      }
    }
  }), _vm._v(" "), _c('ShakeMesh', {
    ref: "@landing@shake@camp",
    attrs: {
      "vms": "@landing@shake@camp",
      "link": require('./img/shake/camp.png')
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s3 = v
      },
      "exec": function (v) {
        _vm.execStack.s3 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@landing@reveal@box-txt-1",
    attrs: {
      "vms": "@landing@reveal@box-txt-1",
      "link": require('./img/shake/box-txt-1.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.r1 = v
      },
      "exec": function (v) {
        _vm.execStack.r1 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@landing@reveal@box-txt-2",
    attrs: {
      "vms": "@landing@reveal@box-txt-2",
      "link": require('./img/shake/box-txt-2.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.r2 = v
      },
      "exec": function (v) {
        _vm.execStack.r2 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@landing@reveal@box-btn-game",
    attrs: {
      "vms": "@landing@reveal@box-btn-game",
      "gclick": function (v) {
        _vm.$router.push('/nike/game/agree')
      },
      "link": require('./img/shake/box-btn-game.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.r3 = v
      },
      "exec": function (v) {
        _vm.execStack.r3 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@landing@reveal@box-btn-comics",
    attrs: {
      "vms": "@landing@reveal@box-btn-comics",
      "gclick": function (v) {
        _vm.$router.push('/nike/game/comic-list')
      },
      "link": require('./img/shake/box-btn-comics.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.r4 = v
      },
      "exec": function (v) {
        _vm.execStack.r4 = v
      }
    }
  }), _vm._v(" "), _c('BoxingArea', {
    ref: "boxing-area",
    attrs: {
      "vms": "@landing@shake@box-canvas"
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "@landing@bg@boxing",
    attrs: {
      "vms": "@landing@bg@boxing",
      "link": require('./img/bg/boxing.jpg')
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@landing@grunge@bg",
      "gOpacity": 0.53,
      "color": 0xbababa
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeBg = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507fb882","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/Pages/BoxingCamp/BoxingCamp.vue
// module id = 590
// module chunks = 0